export default __webpack_public_path__ + "static/media/s3-img.06e1bd9f.png";